import { NgModule } from '@angular/core';
import { UserModule as SharedUserModule } from '@ups/user';
import { UIModule } from '../ui/ui.module';

@NgModule({
  imports: [SharedUserModule, UIModule],
})
export class UserModule {}
